import React, { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { DemoEmployeesPanel } from '../../demo-employees';
import { DemoAppointmentsPanel } from '../../demo-appointments';
import SendTestEmailsPanel from '../send-test-emails/SendTestEmailsPanel';
import '../../components/settings/pages/AccountSettings/AccountSettings.css';
import './DevToolsPage.css';

/**
 * /app/overview/dev/tools — internal demo seeding tools for special admins.
 */
const DevToolsPage = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const cssVars = useMemo(() => {
    const surface = isDark ? '#0f172a' : '#ffffff';
    const surface2 = isDark ? 'rgba(15, 23, 42, 0.72)' : 'rgba(255, 255, 255, 0.7)';
    const text = isDark ? '#e5e7eb' : '#0f172a';
    const muted = isDark ? '#94a3b8' : '#64748b';
    const border = isDark ? 'rgba(148, 163, 184, 0.22)' : 'rgba(15, 23, 42, 0.12)';
    const inputBg = isDark ? 'rgba(2, 6, 23, 0.35)' : 'rgba(255, 255, 255, 0.9)';

    return {
      '--as-surface': surface,
      '--as-surface-2': surface2,
      '--as-text': text,
      '--as-muted': muted,
      '--as-border': border,
      '--as-primary': '#488aec',
      '--as-input-bg': inputBg,
    };
  }, [isDark]);

  return (
    <div className="devToolsPage accountSettingsPage" style={cssVars}>
      <div className="devToolsPage__inner">
        <header className="devToolsPage__header">
          <h1>Developer tools</h1>
          <p>
            Seed demo data and send test emails after applying platform credentials. Special admin
            access only.
          </p>
        </header>

        <div className="devToolsPage__panels">
          <SendTestEmailsPanel />
          <DemoEmployeesPanel />
          <DemoAppointmentsPanel />
        </div>
      </div>
    </div>
  );
};

export default DevToolsPage;
